import './ClientList.scss';

import { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { debounce } from 'lodash';

import { loadClientList } from 'actions/clients';
import Input from 'atoms/input';
import NewAppointmentButton from 'organisms/NewAppointmentButton';
import Table from 'organisms/Table';
import { openDrawer } from 'store/reducers/ui';
import { clientsColumns, clientsColumnsOrder } from 'util/constants';

export const CLIENT_DETAILS_DRAWER = true;

export default function ClientList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { pages, isLoading } = useSelector((state) => state.clientList);
  const [query, setQuery] = useState(null);

  useEffect(() => {
    dispatch(loadClientList({ page: params.page, query }));
  }, [params.page, query]);

  const debounceLoadClientList = useCallback(
    debounce((q) => {
      setQuery(q);
      onChangePage(1);
    }, 1000),
    [params.page, dispatch]
  );

  const updateQuery = (q) => {
    debounceLoadClientList(q);
  };

  const onChangePage = (page) => {
    navigate(`/clients/${page}`);
  };

  const onClientClick = (item) =>
    CLIENT_DETAILS_DRAWER
      ? dispatch(
          openDrawer({
            type: 'client-details',
            data: { auid: item?.animal?.uuid, page: params.page, query },
          })
        )
      : navigate(`/pet-profile/${item?.animal?.uuid}`);

  return (
    <>
      <Helmet title="Clients | PawCare" />
      <div className="w-100 flex-row clients h-100">
        <div className="page-container clients-page-container">
          <div className="flex-row justify-between clients-page-container-header pb-20 pr-30 pl-30">
            <h1>Clients</h1>
            <div className="flex-row gap-12 flex-wrap">
              <Input
                placeholder="Search clients"
                className="clients-search-input mr-10"
                size="small"
                shape="round"
                variant="white"
                onChange={updateQuery}
                value={query}
                icon="search"
              />
              <NewAppointmentButton />
            </div>
          </div>
          <div className="clients-page-container-table-container table-container pb-20">
            <Table
              items={pages[params.page]?.data}
              isLoading={isLoading}
              onClickRow={onClientClick}
              columns={clientsColumns}
              columnsOrder={clientsColumnsOrder}
              pagination={pages[params.page]}
              onChangePage={onChangePage}
            />
          </div>
        </div>
      </div>
    </>
  );
}
